import { CalendarCheck, AlarmClock, CheckCheck, Sparkles, AlertOctagon, LayoutList } from "lucide-react";

const ITEMS = [
  { k: "all", t: "All Active", icon: LayoutList, c: "text-neutral-800" },
  { k: "pending_disposition", m: "pending_dispositions", t: "Pending Outcome", icon: AlertOctagon, c: "text-rose-700" },
  { k: "due_today", m: "due_today", t: "Due Today", icon: CalendarCheck, c: "text-[#1F9E7A]" },
  { k: "overdue", m: "overdue", t: "Overdue", icon: AlarmClock, c: "text-amber-700" },
  { k: "met_today", m: "meetings_done", t: "Meetings Done", icon: CheckCheck, c: "text-emerald-700" },
  { k: "is_new", m: "new_leads", t: "New Leads", icon: Sparkles, c: "text-cyan-700" },
];

export const MetricBar = ({ metrics, total, active, onSelect }) => (
  <div data-testid="metric-bar" className="no-scrollbar -mx-4 flex snap-x gap-3 overflow-x-auto px-4 pb-1 sm:mx-0 sm:px-0">
    {ITEMS.map(({ k, m, t, icon: Icon, c }) => {
      const val = k === "all" ? total : metrics?.[m] ?? 0;
      return (
        <button key={k} type="button" data-testid={`metric-pill-${k.replace(/_/g, "-")}`} onClick={() => onSelect(k)}
          className={`min-w-[132px] snap-start rounded-2xl border p-3 text-left transition-colors duration-150 ${active === k ? "border-[#232323] bg-[#232323] text-white shadow-lg" : "border-neutral-200 bg-white hover:border-neutral-300"}`}>
          <div className={`flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wider ${active === k ? "text-[#F5E04F]" : c}`}><Icon className="h-3.5 w-3.5" />{t}</div>
          <div data-testid={`metric-value-${k.replace(/_/g, "-")}`} className={`mt-1 font-mono text-2xl font-semibold tabular-nums ${active === k ? "text-white" : "text-[#151515]"}`}>{val}</div>
        </button>
      );
    })}
  </div>
);
